<template lang="html">
  <div class="admin-vacancies-scene">
    <div v-if="!loading && !company_loading">
      {{ $tr('admin_console.company.response_refill.next_refill') }} {{ nextRefill }}
    </div>

    <refill-list v-if="!loading" :list="refills" :company-id="companyId" />

    <vpreloader v-else />

    <pagination
      v-if="!loading"
      class="is-admin"
      :params="pagination"
      :on-limit-change="onLimitChange"
      :on-page-change="onPageChange"
    />
  </div>
</template>

<script>
import RefillList from '@/routes_new/inner/admin/company/response_refill/List';
import Pagination from '@/components/shared/admin-pagination';
import Moment from 'moment';

import { STORE_PREFIX } from '../constants.js';
import { mapGetters } from 'vuex';

export default {
  name: 'AdminResponseRefillScene',

  components: {
    RefillList,
    Pagination
  },

  props: {
    companyId: null
  },

  computed: {
    ...mapGetters(STORE_PREFIX + 'admin', {
      pagination: 'refills/pagination',
      company: 'company/one',
      company_loading: 'company/loading',
      loading: 'refills/loading',
      refills: 'refills/list'
    }),

    nextRefill() {
      let refill = this.refills[0]
        ? Moment(this.refills[0].created_at).add(1, 'M').format(this.dateFormat)
        : null;

      if (refill === null) {
        refill = Moment(this.company.created_at).add(1, 'M').format(this.dateFormat);
      }
      return refill;
    },

    dateFormat() {
      return this.is_japan_locale ? 'YYYY.MM.DD' : 'DD.MM.YYYY';
    }
  },

  beforeMount() {
    this.fetchCompany();
    this.fetch();
  },

  destroyed() {
    this.$store.commit(STORE_PREFIX + 'admin/refills/clear');
  },

  methods: {
    fetch() {
      this.$store.dispatch(STORE_PREFIX + 'admin/refills/fetch', this.companyId);
    },

    onPageChange(pageNumber) {
      this.$store.commit(STORE_PREFIX + 'admin/refills/updatePagination', {
        pageNumber
      });
      this.fetch();
    },

    onLimitChange(count) {
      this.$store.commit(STORE_PREFIX + 'admin/refills/updatePagination', {
        count
      });
      this.fetch();
    },

    fetchCompany() {
      this.$store.dispatch(STORE_PREFIX + 'admin/company/fetch', this.companyId);
    }
  }
};
</script>

<style lang="scss" scoped>
.pagination:first-child {
  padding: 0 0 20px 0;
}
</style>
